module.exports = __webpack_public_path__ + "static/img/hxyw_21.591fb65.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Images/hxyw_21.png
// module id = /Ft3
// module chunks = 1